
import React from 'react';

export default function NoNeedToWorry() {
  const points = [
    {
      icon: 'ri-government-line',
      title: '国の規制で守られている',
      description:
        '日本のFX業者は金融庁の厳しい規制下にあります。レバレッジ上限25倍、信託保全の義務化、ロスカットルールなど、投資家保護の仕組みが法律で整備されています。海外の無規制業者とは根本的に異なります。',
    },
    {
      icon: 'ri-line-chart-line',
      title: 'FXで利益を出している人も多い',
      description:
        '金融先物取引業協会の調査によると、FX取引で利益を出している個人投資家は約6割というデータもあります。正しい知識と適切なリスク管理があれば、FXは十分に利益を狙える投資手段です。',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'DMM FXは国内最大級の実績',
      description:
        'FX口座数90万口座突破（2024年1月時点）という実績が、多くのトレーダーからの信頼の証です。長年にわたり安定したサービスを提供し続けています。',
    },
    {
      icon: 'ri-tools-line',
      title: 'リスク管理ツールが充実',
      description:
        'DMM FXには損切り注文、利益確定注文、OCO注文など、リスクを管理するための注文方法が豊富に用意されています。これらを活用すれば、損失を自分でコントロールできます。',
    },
    {
      icon: 'ri-graduation-cap-line',
      title: 'デモ取引で無料練習できる',
      description:
        '実際のお金を使わずに取引の練習ができるデモ口座が用意されています。操作方法や相場の動きに慣れてから本番に臨めるので、初心者でも安心です。',
    },
    {
      icon: 'ri-hand-heart-line',
      title: '少額から始められる',
      description:
        'DMM FXでは1万通貨単位から取引可能。米ドル/円なら約5,000円程度の証拠金から始められます。大きな資金を用意する必要はありません。',
    },
  ];

  // Defensive rendering: ensure points is an array
  const renderedPoints = Array.isArray(points) ? points : [];

  return (
    <section className="py-16 bg-gradient-to-b from-white to-teal-50/30">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-12 h-12 bg-emerald-100 rounded-lg mb-4">
            <i className="ri-emotion-happy-line text-2xl text-emerald-600"></i>
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-4">過度な心配はいりません</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            FXにリスクがあるのは事実ですが、正しい知識と適切な対策があれば、過度に恐れる必要はありません。
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {renderedPoints.map((point, i) => (
            <div
              key={i}
              className="bg-white rounded-xl p-6 shadow-sm border border-gray-100"
            >
              <div className="w-10 h-10 bg-emerald-50 rounded-lg flex items-center justify-center mb-4">
                <i className={`${point.icon} text-xl text-emerald-600`}></i>
              </div>
              <h3 className="text-base font-bold text-gray-900 mb-2">{point.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{point.description}</p>
            </div>
          ))}
        </div>

        {/* 海外FXとの比較 */}
        <div className="mt-12 max-w-4xl mx-auto">
          <h3 className="text-xl font-bold text-gray-900 mb-6 text-center">
            <a href="#comparison" className="hover:text-teal-600 transition-colors">
              国内FX vs 海外FX：安全性の比較
            </a>
          </h3>
          <div className="bg-white rounded-xl shadow-md overflow-hidden border border-gray-100">
            <div className="overflow-x-auto">
              <table className="w-full text-sm">
                <thead>
                  <tr className="bg-gray-50">
                    <th className="text-left px-6 py-4 font-semibold text-gray-700">
                      比較項目
                    </th>
                    <th className="text-center px-6 py-4 font-semibold text-teal-700">
                      <span className="inline-flex items-center">
                        <i className="ri-check-double-line text-teal-500 mr-1 w-4 h-4 flex items-center justify-center"></i>
                        DMM FX（国内）
                      </span>
                    </th>
                    <th className="text-center px-6 py-4 font-semibold text-gray-500">
                      海外FX業者
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {[
                    { item: '金融庁登録', domestic: '登録済み', overseas: '未登録が多い' },
                    { item: '信託保全', domestic: '全額信託保全（義務）', overseas: '義務なし' },
                    { item: 'レバレッジ上限', domestic: '最大25倍（法規制）', overseas: '数百〜数千倍' },
                    { item: '出金トラブル', domestic: 'ほぼなし', overseas: '報告多数' },
                    { item: 'サポート', domestic: '日本語24時間対応', overseas: '日本語非対応も' },
                    { item: '税制', domestic: '申告分離課税20.315%', overseas: '総合課税（最大55%）' },
                  ].map((row, i) => (
                    <tr
                      key={i}
                      className={i % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'}
                    >
                      <td className="px-6 py-3.5 font-medium text-gray-700">{row.item}</td>
                      <td className="px-6 py-3.5 text-center text-teal-700 font-medium">
                        {row.domestic}
                      </td>
                      <td className="px-6 py-3.5 text-center text-gray-500">{row.overseas}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
